import { css } from '@emotion/react'
import React from 'react'

const headingCss = ({ font, colors }) => css`
  &.heading {
    font-weight: 400;
  }

  > a {
    margin: 0;
    display: inline;
    text-decoration: none;
    font-weight: ${font.bold};
    font-size: 18px;

    &:hover {
      color: ${colors.black900};
    }
  }
`

const ProductsHeading = () => {
  return (
    <h3 css={headingCss} className="heading">
      Our <a href="https://text.com/">Text</a> products
    </h3>
  )
}

export default ProductsHeading
